module.exports = __webpack_public_path__ + "img/userC07.e4de75f4.jpg";